// extracted by mini-css-extract-plugin
module.exports = {"search_icon":"suggestion_search_icon__1D402","type":"suggestion_type__3Dzix"};